import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= WEST BENGAL CITY DATA ================= */

const westBengalCities = [
  { slug: "kolkata", city: "Kolkata", state: "West Bengal" },
  { slug: "howrah", city: "Howrah", state: "West Bengal" },
  { slug: "durgapur", city: "Durgapur", state: "West Bengal" },
  { slug: "asansol", city: "Asansol", state: "West Bengal" },
  { slug: "siliguri", city: "Siliguri", state: "West Bengal" }
];

const WestBengal = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <>
        <Helmet>
          <title>
            Sex Toys Delivery in West Bengal | Discreet Adult Store Online
          </title>
          <meta
            name="description"
            content="Buy sex toys online in West Bengal with 100% discreet delivery. Trusted adult store delivering to Kolkata, Howrah, Durgapur, Asansol, Siliguri & more."
          />
          <link
            rel="canonical"
            href="https://lushdesire.in/sex-toys-delivery/west-bengal"
          />
        </Helmet>

        <div
          style={{
     
            padding: "25px",
            backgroundColor: "#FFF5F5",
            minHeight: "90vh",
            lineHeight: "1.8"
          }}
        >
          <h1>Sex Toys Delivery in West Bengal</h1>

          <p>
            Buy premium <strong>sex toys in West Bengal</strong> with fast,
            safe, and <strong>100% discreet delivery</strong>. LushDesire is a
            trusted Indian adult wellness store offering high-quality pleasure
            products for men, women, and couples across West Bengal.
          </p>

          <h2>Cities We Serve in West Bengal</h2>

          <ul>
            {westBengalCities.map((c) => (
              <li key={c.slug}>
                <Link to={`/sex-toys-delivery/west-bengal/${c.slug}`}>
                  Sex Toys in {c.city}
                </Link>
              </li>
            ))}
          </ul>

          <h3>Why Buy Sex Toys Online from LushDesire?</h3>
          <ul>
            <li>✔ Genuine & body-safe products</li>
            <li>✔ Plain, discreet packaging</li>
            <li>✔ Cash on Delivery available</li>
            <li>✔ Fast delivery across West Bengal</li>
          </ul>

          <p>
            Order online today and enjoy private, secure shopping from
            West Bengal’s trusted adult toy store.
          </p>
        </div>
      </>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = westBengalCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in West Bengal
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys and couples wellness products available in ${cityData.city}, West Bengal.`}
        />
        <link
          rel="canonical"
          href={`https://lushdesire.in/sex-toys-delivery/west-bengal/${cityData.slug}`}
        />
      </Helmet>
<CategorySlider />

      <div
        style={{
      
          padding: "25px",
          backgroundColor: "#FFF5F5",
          minHeight: "90vh",
          lineHeight: "1.8"
        }}
      >
        <h1>Sex Toys in {cityData.city} – Discreet Home Delivery</h1>

        <p>
          Looking to buy <strong>sex toys in {cityData.city}</strong>? LushDesire
          offers premium adult wellness products with complete privacy and fast
          delivery across {cityData.city} and nearby locations.
        </p>

        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Shopping for sex toys online in {cityData.city} is now safe, private,
          and convenient. Our curated range helps couples and individuals
          explore intimacy, confidence, and pleasure comfortably.
        </p>

        <h3>Popular Adult Toys Available</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Pleasure Toys</li>
          <li>✔ Couples Intimacy Products</li>
          <li>✔ Male & Female Wellness Toys</li>
        </ul>

        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet Packaging</li>
          <li>✔ Fast Local Delivery</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Trusted Indian Adult Store</li>
        </ul>

        <h4>Discreet Sex Toys Delivery in {cityData.city}</h4>
        <p>
          Every order is shipped in plain packaging with no product names or
          adult branding. Your privacy is fully protected from checkout to
          delivery.
        </p>

        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Place your order today and enjoy premium adult wellness products with
          fast delivery, secure payments, and complete peace of mind.
        </p>

        <p>
          <strong>LushDesire</strong> – India’s trusted online sex toy store.
        </p>
      </div>
    </>
  );
};

export default WestBengal;
